import { SharedService } from '@/app/shared/services/shared.service';
import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
// import { Paginate } from '@/app/shared/interface/pagination.interface';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {

  @Input() public total: number | null | undefined;
  @Input() public currentPage: number | undefined;
  @Input() public pageSize: number | undefined;
  @Input() public paginateRange: number = 7;
  @Input() public lazyCount = false;
  @Input() public countLoading = false;
  @Input() public hasNextPage = false;
  @Input() public hasPreviousPage = false;
  @Input() public itemCount = 0;
  @Input() public pageSizePosition: 'top' | 'bottom' = 'top';
  @Input() public pageSizeOptions: number[] = [20, 30, 50];
  @Output() public pageSizeChange: EventEmitter<number> = new EventEmitter();

  @Output() setPage: EventEmitter<number> = new EventEmitter();
  @Output() countRequested = new EventEmitter<void>();

  public paginate: any; // Pagination use only
  
  constructor(private sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router) { }

  // Detect changes
  ngOnChanges(changes: SimpleChanges) {
    this.total = changes['total'] ? changes['total'].currentValue : this.total;
   
    this.currentPage = changes['currentPage'] ? changes['currentPage'].currentValue : this.currentPage;
    this.pageSize = changes['pageSize'] ? changes['pageSize'].currentValue : this.pageSize;
    // Get Pager For Pagination
    if (!this.lazyCount) {
      this.paginate = this.sharedService.getPager(this.total!, this.currentPage!, this.pageSize!, this.paginateRange);
    }
  }

  get startItem(): number {
    return this.itemCount ? ((Number(this.currentPage) || 1) - 1) * Number(this.pageSize) + 1 : 0;
  }

  get maxPage(): number {
    return Math.max(1, Math.ceil(Number(this.total) / Number(this.pageSize)));
  }

  get endItem(): number {
    return this.itemCount ? this.startItem + this.itemCount - 1 : 0;
  }

  lazyPageSet(page: number) {
    const maxPage = this.total === null || this.total === undefined ? Infinity : Math.max(1, Math.ceil(this.total / Number(this.pageSize)));
    if (!Number.isInteger(page) || page < 1 || page > maxPage || page === this.currentPage) return;
    this.router.navigate([], { relativeTo: this.route, queryParams: { page }, queryParamsHandling: 'merge', replaceUrl: true });
    this.setPage.emit(page);
  }

  // Set Page
  pageSet(page: number) {
    this.setPage.emit(page);  // Set Page Number  
  }

  onLazyPageChanged(e: Event) {
    const input = e.target as HTMLInputElement;
    const page = Number(input.value);
    const maxPage = this.total === null || this.total === undefined ? (this.hasNextPage ? Number(this.currentPage) + 1 : Number(this.currentPage)) : Math.max(1, Math.ceil(this.total / Number(this.pageSize)));
    if (Number.isInteger(page) && page >= 1 && page <= maxPage) this.lazyPageSet(page);
    else input.value = String(this.currentPage || 1);
  }

  onPageChanged(e: any) {
    if (e.target.value != "") {
      this.currentPage = Number(e.target.value);
      if (this.currentPage > this.paginate.totalPages) {
        this.currentPage = this.paginate.totalPages;
      }
    }
    else {
      this.currentPage = 1;
    }
    this.router.navigate([], { relativeTo: this.route, queryParams: { page: this.currentPage}, queryParamsHandling: 'merge', replaceUrl: true });
    this.setPage.emit(this.currentPage);
  }

  onPageSizeChanged(e: any) {
    const val = Number(e?.target?.value);
    if (val > 0) {
      this.pageSize = val;
      this.pageSizeChange.emit(val);
    }
  }

}
